// import type { MutationTree } from 'vuex';
import type { ProductPickerState, Product } from '../type';
import { mutationTypes } from './types';

const mutations = {
  [mutationTypes.ADD_PICKED_PRODUCT](state: ProductPickerState, value: Product) {
    state.list.push(value);
  },
  [mutationTypes.SET_PRODUCT_MODULE_ID](state: ProductPickerState, value: number) {
    state.productModuleId = value;
  },
  [mutationTypes.SET_SELECTOR_ELEMENT](state: ProductPickerState, value: boolean) {
    state.selecterElement = value;
  },
  [mutationTypes.SET_IS_OPEN_POPUP](state: ProductPickerState, value: boolean) {
    state.isOpenPopup = value;
  },
  [mutationTypes.SET_IS_LOADING](state: ProductPickerState, value: boolean) {
    state.isLoading = value;
  },
  [mutationTypes.SET_IS_REFRESH](state: ProductPickerState, value: boolean) {
    state.isRefresh = value;
  },
  [mutationTypes.SET_IS_MESSAGE](state: ProductPickerState, value: boolean) {
    state.isMessage = value;
  },
  [mutationTypes.SET_QUERY](state: ProductPickerState, value: string) {
    state.query = value;
  },
  [mutationTypes.SET_QUERY_LIST](state: ProductPickerState, list: Product[]) {
    state.queryList = [...list];
  },
  [mutationTypes.SET_FETCHED_ALL](state: ProductPickerState) {
    state.fetched = true;
  },
  [mutationTypes.SET_FETCHED_ALL_QUERY](state: ProductPickerState) {
    state.queryFetched = true;
  },
  [mutationTypes.RESET_SEARCH_RESULT](state: ProductPickerState) {
    state.queryList = [];
    state.queryFetched = false;
    state.endCursorQuery = '';
  },

  [mutationTypes.RESET_PRODUCT_DATA](state: ProductPickerState) {
    state.query = '';
    state.list = [];
    state.queryList = [];
    state.fetched = false;
    state.queryFetched = false;
    state.endCursor = '';
    state.endCursorQuery = '';
  },
};

export default mutations;
